// WARN: Import order is important on entrypoint script, do not change if not sure what you are doing :)

// vue and its plugins
import { createApp, Plugin } from 'vue';
import { pinia } from '@/store';
import { i18n } from '@/libs/i18n';
import { VeeValidatePlugin } from '@/libs/vee-validate';
import { abilitiesPlugin } from '@casl/vue';
import ability from '@/libs/acl/ability';
import router from '@/router';
import VueFeather from 'vue-feather';

// 3rd party styles
import 'highlight.js/styles/atom-one-dark.css'
import 'vue-select/dist/vue-select.css';

// 3rd party global libraries (e.g. bootstrap)
import 'bootstrap';
import '@popperjs/core';
import 'choco-core-package';
import 'choco-edm-core-package';
import '@/libs/edm/EDMBlockPlugin';
import vSelect from 'vue-select';
import VueGridLayout from 'vue-grid-layout';
import ganttastic from '@infectoone/vue-ganttastic';

// application styles
import '@/assets/styles/base/global.scss';
import '@/assets/styles/app.scss';

// entry component
import App from '@/App.vue';

// directive
import vPermission from './directives/permission-directive';

// for boot/setup modules
import { useSettingStore } from '@/store/settingStore';

// app plugins
import btTooltips from '@/plugins/bt-tooltips';

// Toast Notification
import Toast, { PluginOptions as ToastPluginOptions } from 'vue-toastification';
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css';

// global configuration for highlight.js
import hljs from 'highlight.js/lib/core';
import hljsSql from 'highlight.js/lib/languages/sql';

hljs.registerLanguage('sql', hljsSql);

// Create Vue (3) application
const app = createApp(App);
// Initialize Pinia before accessing any stores
app.use(pinia);

// Ensure store-dependent logic is executed after Pinia setup
const settingStore = useSettingStore(pinia);
settingStore.setupLocale();

// Use plugins and libraries
app.use(i18n);
app.use(VeeValidatePlugin);
app.use(router);

// Router is used after Pinia setup
app.use(abilitiesPlugin, ability, { useGlobalProperties: true });
app.use(btTooltips);
app.use(ganttastic as Plugin);
app.use(VueGridLayout);
app.use(Toast, <ToastPluginOptions>{ maxToasts: 5 });
app.component('v-select', vSelect);
app.component(VueFeather.name as string, VueFeather);
app.directive('permission', vPermission);

// Mount the app
app.mount('#app');
